import { Outlet, useLocation } from "react-router-dom";
import SettingsMenu from "@/pages/settings/components/SettingsMenu";
import { useState, useEffect } from "react";

const SettingsList = () => {
  const location = useLocation();
  const [showMobileContent, setShowMobileContent] = useState(false);

  // Determine if we should show content based on route
  useEffect(() => {
    const path = location.pathname;
    // If we're on a specific settings page (not just /settings)
    setShowMobileContent(path.split("/").length > 3);
  }, [location]);

  return (
    <div className="relative w-full h-full">
      {/* Fixed Settings Menu section - positioned within the content area */}
      <div
        className="hidden lg:block lg:fixed lg:w-[350px]"
        style={{
          height: "calc(100vh - 64px)",
          top: "64px", // Match your header height
          left: "var(--sidebar-width)", // Match your dashboard sidebar width
        }}>
        <div className="lg:overflow-y-auto lg:h-full lg:pr-3 hide-scrollbar">
          <SettingsMenu />
        </div>
      </div>

      {/* Settings Content section with appropriate margin */}
      <div className="hidden lg:block" style={{ marginLeft: "calc(370px)" }}>
        <div className="py-6">
          <Outlet />
        </div>
      </div>

      {/* Mobile view - conditionally show menu or content */}
      <div className="lg:hidden">
        {showMobileContent ? (
          <div>
            <div className="py-4">
              <Outlet />
            </div>
          </div>
        ) : (
          <SettingsMenu />
        )}
      </div>
    </div>
  );
};

export default SettingsList;
